import React from "react";
import akanthasOwl from "../../static/assets/akanthasOwl.svg";

/** Akanthas owl mark (Figma) for the round header menu button. */
const AkanthasOwlIcon = ({ className, size = 27, alt = "" }) => (
  <img
    className={className}
    src={akanthasOwl}
    width={size}
    height={size}
    alt={alt}
    draggable={false}
  />
);

export default AkanthasOwlIcon;
